import BaseApi from "./baseApi";

class RetreatApi extends BaseApi {
  async createRetreat(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreat/createRetreat",
      data: data,
      method: "post",
    });
  }

  async getAllRetreats(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreat/getAllRetreats",
      data: data,
      method: "post",
    });
  }

  async getAllRetreatSearch(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreat/getAllRetreatSearch",
      data: data,
      method: "post",
    });
  }

  async getRetreatDetail(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreat/getRetreatDetail",
      data: data,
      method: "post",
    });
  }

  async getRetreatDetailRos(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreat/getRetreatDetailRos",
      data: data,
      method: "post",
    });
  }

  async editRetreat(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreat/editRetreat",
      data: data,
      method: "post",
    });
  }

  async tempDeleteRetreat(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreat/tempDeleteRetreat",
      data: data,
      method: "post",
    });
  }

  async searchKey(key: string): Promise<any> {
    return await this.API({
      url: `/retreat/search/${key}`,
      method: "get",
    });
  }

  async searchRetreatsAndCouples(query: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: `/retreat/searchRetreatsAndCouples`,
      method: "post",
      data: query,
    });
  }

  async getRetreatLocation(): Promise<any> {
    return await this.API({
      url: `/retreat/getRetreatLocation`,
      method: "post",
    });
  }

  async autoSaveRetreat(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: `/retreat/autoSaveRetreat`,
      method: "post",
      data: data,
    });
  }

  async giveAccesssOfApprove(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: `/retreat/giveAccesssOfApprove`,
      method: "post",
      data: data,
    });
  }

  async removeAccessFromRetreat(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: `/retreat/removeAccessFromRetreat`,
      method: "post",
      data: data,
    });
  }

  async getAllAccessedRetreats(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/retreat/getAllAccessedRetreats",
      method: "post",
      data: data,
    });
  }

  async allretreatSubAdmins(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/retreat/allretreatSubAdmins",
      method: "post",
      data: data,
    });
  }

  async retreatAdminAccess(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/retreat/retreatAdminAccess",
      method: "post",
      data: data,
    });
  }

  async uploadFiles(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/retreat/uploadFiles",
      data: data,
      method: "post",
    });
  }

  async deleteFile(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/retreat/deleteFile",
      method: "post",
      data: data,
    });
  }

  async retreatFreeze(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/retreat/retreat-freeze",
      method: "post",
      data: data,
    });
  }

  async handleConfirmation(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/retreat/handle-confirmation",
      method: "post",
      data: data,
    });
  }

  async retreatChangeStatus(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/retreat/retreat-change-status",
      method: "post",
      data: data,
    });
  }

  async retreatCloseStatus(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/retreat/retreat-close-Status",
      method: "post",
      data: data,
    });
  }

  async getSelectedRetreatData(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/retreat/get-selected-retreat-data",
      method: "post",
      data: data,
    });
  }

  async getAllRetreatData(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/retreat/get-all-retreat-data",
      method: "post",
      data: data,
    });
  }

  async retreatDisabledSubAdmin(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/retreat/retreat-disabled-sub-admin",
      method: "post",
      data: data,
    });
  }

  async retreatCloseMailSent(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/retreat/retreat-close-mail-sent",
      method: "post",
      data: data,
    });
  }

  async getPassword(): Promise<any> {
    return await this.API({
      url: "/registration-password/get-password",
      method: "get",
    });
  }

  async getManageDashboard(data: Record<string, unknown> | object = {}): Promise<any> {
    return this.API({
      url: "/retreat/manage-dashboard",
      data,
      method: "post",
    });
  }

  async listByStatus(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreat/list-by-status",
      data,
      method: "post",
    });
  }

  async createProjectedRetreat(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/auth/create-projected",
      data,
      method: "post",
    });
  }

  async updateProjectedRetreat(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/auth/update-projected",
      data,
      method: "post",
    });
  }

  async startRetreatSetup(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/auth/confirm-to-setup",
      data,
      method: "post",
    });
  }

  async getRetreatSetupDetail(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/auth/setup-detail",
      data,
      method: "post",
    });
  }

  async saveRetreatSetupProgress(
    data: Record<string, unknown> | object | FormData,
  ): Promise<any> {
    return this.API({
      url: "/retreat/save-setup-progress",
      data,
      method: "post",
    });
  }

  async submitRetreatForReview(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreat/submit-for-review",
      data,
      method: "post",
    });
  }

  async approveAndPublishRetreat(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreat/approve-publish",
      data,
      method: "post",
    });
  }

  async requestPublicationChanges(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreat/request-publication-changes",
      data,
      method: "post",
    });
  }

  async getSetupMailRecipients(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreat/setup-mail-recipients",
      data,
      method: "post",
    });
  }

  async sendSetupMail(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreat/send-setup-mail",
      data,
      method: "post",
    });
  }

  async softDeleteRetreat(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreat/soft-delete",
      data,
      method: "post",
    });
  }

  async restoreDeletedRetreat(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreat/restore-deleted",
      data,
      method: "post",
    });
  }

  async moveToClosing(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreat/move-to-closing",
      data,
      method: "post",
    });
  }

  async completeRetreat(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreat/complete-retreat",
      data,
      method: "post",
    });
  }

  async getRetreatHistory(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreat/retreat-history",
      data,
      method: "post",
    });
  }
}

export default RetreatApi;
